import { ScopeKey } from '@/core/enums/scopeKey';
import { UserInfoScopes } from '@/core/collections/api/user/user-info.interface';

type ScopeCategory = keyof UserInfoScopes;

export function useUserScopes() {
   const { state } = useStore();

   const scopes = computed(() => state.user?.user_info?.scopes);

   function hasCategoryAccess(category: ScopeCategory): boolean {
      return category in (scopes.value ?? {});
   }

   function hasScope(category: ScopeCategory, scope: ScopeKey): boolean {
      return scopes.value?.[category]?.includes(scope) ?? false;
   }

   const isSuperAdmin = computed(() => hasScope('supers', ScopeKey.admin));

   const hasBoardView = computed(() => isSuperAdmin.value || hasCategoryAccess('boards'));
   const hasBoardCreate = computed(() => isSuperAdmin.value || hasScope('boards', ScopeKey.create));
   const hasBoardAdmin = computed(() => isSuperAdmin.value || hasScope('boards', ScopeKey.admin));
   const hasBoardCommunications = computed(() => isSuperAdmin.value || hasCategoryAccess('boards'));

   const hasPoolView = computed(() => isSuperAdmin.value || hasCategoryAccess('pools'));
   const hasPoolAdmin = computed(() => isSuperAdmin.value || hasScope('pools', ScopeKey.admin));

   const hasCandidateCreate = computed(() => isSuperAdmin.value || hasScope('candidates', ScopeKey.create));
   const hasCandidateUpdate = computed(() => isSuperAdmin.value || hasScope('candidates', ScopeKey.update));

   const hasTenantAdmin = computed(() => isSuperAdmin.value || hasCategoryAccess('tenants'));


   return {
      scopes,
      hasScope,

      hasBoardView,
      hasBoardCreate,
      hasBoardAdmin,
      hasBoardCommunications,

      hasPoolView,
      hasPoolAdmin,

      hasCandidateCreate,
      hasCandidateUpdate,

      hasTenantAdmin,

      isSuperAdmin,
   };
}
